import { Pipe, PipeTransform } from '@angular/core';
import { FuncMinutes2Format, SecondsOutputFormat } from './funcMinutes2HourFormat';

@Pipe({
    name: 'formatSeconds'
})
export class FormatSecondsPipe implements PipeTransform {

    transform(value: number, pattern: SecondsOutputFormat) : string {
        try {
            return FuncMinutes2Format.RenderSeconds(value, pattern);
        } catch {
            return '';
        }
    }
}
